import React, { useState } from 'react';
import CommonHeader from './CommonHeader';
import CommonFooter from './CommonFooter';
import config from '../config';
import './ContactUs.css';

const ContactUs = ({ onNavigate, onLogin, onSignup }) => {
  const costPerPdf = parseFloat(config.COST_PER_PDF)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(`${config.API_BASE_URL}/api/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(data.message);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <CommonHeader
        activePage="contact"
        onNavigate={onNavigate}
        onLogin={onLogin}
        onSignup={onSignup}
      />

      <div className="contact-container">
        <div className="contact-wrapper">
          <div className="contact-header">
            <h1>Contact Us</h1>
            <p>Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
          </div>

          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info">
              <div className="info-card">
                <div className="info-icon">📍</div>
                <h3>Visit Us</h3>
                {/* <p>123 Business Avenue<br />Suite 100<br />San Francisco, CA 94105</p>  */}
              </div>

              <div className="info-card">
                <div className="info-icon">📧</div>
                <h3>Email Us</h3>
                {/* <p><a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a></p>
                <p><a href={`mailto:${config.SALES_EMAIL}`}>{config.SALES_EMAIL}</a></p> */}
              </div>

              <div className="info-card">
                <div className="info-icon">📞</div>
                <h3>Call Us</h3>
                {/* <p><a href="tel:+1-800-555-0123">+1 (800) 555-0123</a></p> */}
                <p>Mon-Fri, 9am - 6pm PST</p>
              </div>

              <div className="info-card">
                <div className="info-icon">💬</div>
                <h3>Support Hours</h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM IST</p>
                <p>Sunday: Closed</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <form onSubmit={handleSubmit} className="contact-form">
                {success && (
                  <div className="success-message">
                    <span>✓</span> {success}
                  </div>
                )}
                
                {error && (
                  <div className="error-message">
                    <span>⚠️</span> {error}
                  </div>
                )}

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                      disabled={loading}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="How can we help you?"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    placeholder="Please describe your question or issue in detail..."
                    disabled={loading}
                  />
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-grid">
              <div className="faq-item">
                <h3>What is {config.APP_NAME}?</h3>
                <p>{config.APP_NAME} is a form building platform that allows you to create custom forms, collect responses, and generate professional PDFs instantly.</p>
              </div>
              <div className="faq-item">
                <h3>How does pricing work?</h3>
                <p>We offer a free plan with limited features and a usage plan where you pay only for PDF generations (${costPerPdf} per PDF).</p>
              </div>
              <div className="faq-item">
                <h3>Do you store my data?</h3>
                <p>No! We designed {config.APP_NAME} as a "fill and print" platform. We do not permanently store your form responses or submitted data.</p>
              </div>
              <div className="faq-item">
                <h3>Can I upgrade my plan?</h3>
                <p>Yes! You can upgrade from Free to Usage plan at any time from your Analytics dashboard.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CommonFooter onNavigate={onNavigate} activePage="contact" />
    </div>
  );
};

export default ContactUs;